var _excluded = ["spanMethod", "rowHeight", "headProps", "fixedHeader", "onHead", "headGroupHeight", "headRowHeight", "bodyProps", "bodyClassName", "bodyStyle", "rowProps", "rowClassName", "onRow", "footer", "footerClassName", "footerStyle"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { createContext, useContext, useMemo } from 'react';
import { clampRound, isFunction, isNumber, isObject } from '@okee-uikit/react-utils';
import { useRefCallback } from '@okee-uikit/react-hooks';
import { useTable } from '../context';

function clampRowSpan(rowSpan) {
  if (isNumber(rowSpan)) {
    return clampRound(rowSpan, 0, 65534);
  }

  return undefined;
}

function clampColSpan(colSpan) {
  if (isNumber(colSpan)) {
    if (colSpan < 0) {
      return 0;
    }

    if (colSpan > 1000) {
      return undefined;
    }

    return Math.round(colSpan);
  }

  return undefined;
}

export function useTableSectionsInit(props, rowBordered) {
  var propSpanMethod = props.spanMethod,
      rowHeight = props.rowHeight,
      propHead = props.headProps,
      fixedHeader = props.fixedHeader,
      onHead = props.onHead,
      headGroupHeight = props.headGroupHeight,
      headRowHeight = props.headRowHeight,
      propBody = props.bodyProps,
      bodyClassName = props.bodyClassName,
      bodyStyle = props.bodyStyle,
      propRow = props.rowProps,
      rowClassName = props.rowClassName,
      onRow = props.onRow,
      footer = props.footer,
      footerClassName = props.footerClassName,
      footerStyle = props.footerStyle,
      attrs = _objectWithoutProperties(props, _excluded);

  var tableContext = useTable();
  var spanMethod = useRefCallback(function (row, col) {
    if (isFunction(propSpanMethod)) {
      var spanning = propSpanMethod(row, col, tableContext);

      if (spanning) {
        return {
          rowSpan: clampRowSpan(spanning.rowSpan),
          colSpan: clampColSpan(spanning.colSpan)
        };
      }
    }

    return {};
  });

  if (!isFunction(propRow)) {
    if (isObject(propRow)) {
      var p = propRow;

      propRow = function propRow() {
        return p;
      };
    } else if (isFunction(onRow)) {
      var f = onRow;

      propRow = function propRow(_ref) {
        var row = _ref.row;
        return f(row);
      };
    } else if (isFunction(rowClassName)) {
      var _f = rowClassName;

      propRow = function propRow(_ref2) {
        var row = _ref2.row,
            index = _ref2.index;
        return {
          className: _f(row, index),
          rowHeight: rowHeight
        };
      };
    } else {
      var _p = {
        className: rowClassName,
        rowHeight: rowHeight
      };

      propRow = function propRow() {
        return _p;
      };
    }
  }

  var rowProps = useRefCallback(propRow);
  var context = useMemo(function () {
    return {
      rowBordered: rowBordered,
      spanMethod: spanMethod,
      rowProps: rowProps
    };
  }, [rowBordered]);
  var headInfo = {
    props: !isFunction(propHead) && propHead || {
      sticky: fixedHeader,
      rowHeight: headRowHeight !== null && headRowHeight !== void 0 ? headRowHeight : rowHeight
    },
    callback: isFunction(propHead) && propHead || onHead || function () {
      return {};
    }
  };
  var bodyInfo = {
    props: !isFunction(propBody) && propBody || {
      className: bodyClassName,
      style: bodyStyle
    },
    callback: isFunction(propBody) && propBody || function () {
      return {};
    }
  };
  return [context, attrs, headInfo, bodyInfo];
}
export var SectionsContext = createContext(undefined);
export var useTableSections = function useTableSections() {
  return useContext(SectionsContext);
};